import { WorkflowAdditionalOptionsSpouseSubBaseService } from "app/core/workflow/workflow-steps/spouse/sub/workflow-additional-options-spouse-sub-base.service";

export class WorkflowAdditionalOptionsSpouseTwoService extends WorkflowAdditionalOptionsSpouseSubBaseService {
  public get subStepNumber(): number {
    return 3;
  }
}
